import { useTranslation } from "react-i18next";
import { BulkMessageSendOptionInput } from "@/__generated__/graphql";
import { formatDate } from "@/lib/formatDate";
import { useLocale } from "@/hooks/useLocale";
import { timestampToDate } from "@/util/dateUtils";

interface SendOptionTextProps {
  sendOption?: BulkMessageSendOptionInput;
  timeZone?: string;
}

export function SendOptionText({ sendOption, timeZone }: SendOptionTextProps) {
  const locale = useLocale();
  const { t } = useTranslation("translation", {
    keyPrefix: "bulkMessaging.review",
  });

  if (sendOption?.sendNow) {
    return t("sendNow");
  } else if (sendOption?.sendLater) {
    const sendDate = timestampToDate(
      sendOption.sendLater.startSendingAt,
      timeZone,
    );
    const formattedMessage = t("sendLater", {
      sendDate: formatDate(sendDate, "PPPp", { locale }),
    });

    return `${formattedMessage} (${timeZone || t("missingTimeZone")})`;
  } else if (sendOption?.startCampaign) {
    const startDate = timestampToDate(
      sendOption.startCampaign.startSendingAt,
      timeZone,
    );
    const endDate = timestampToDate(
      sendOption.startCampaign.stopSendingAt,
      timeZone,
    );

    const formattedMessage = t("startCampaign", {
      startDate: formatDate(startDate, "PPP", { locale }),
      endDate: formatDate(endDate, "PPP", { locale }),
    });

    return `${formattedMessage} (${timeZone || t("missingTimeZone")})`;
  } else {
    return "-";
  }
}
